import { Search } from '../components/Search';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import ReportLibraryButton from '../../components/ReportLibraryButton';
import { Header } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderContainer = () => {
  return /*#__PURE__*/_jsx(Header, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "smartLibrary.heading.title"
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "400",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Search, {}), /*#__PURE__*/_jsx(ReportLibraryButton, {})]
    })
  });
};